import { COURSE_MAP } from '../constants/course'
import { PLAN_MAP } from '../constants/plan'

function calcNormal(amountMoney) {
  if (amountMoney < 200001) {
    //1～100,000円　10,000円／月
    return 10000
  } else {
    //200,001円～、100,000円増すごとに　5,000円ずつ加算
    return 10000 + 5000 * Math.ceil((amountMoney - 200000) / 100000)
  }
}

function calcLeeway(amountMoney) {
  if (amountMoney < 100001) {
    return 4000
  } else if (amountMoney < 200001) {
    return 8000
  } else if (amountMoney < 300001) {
    return 12000
  } else if (amountMoney < 400001) {
    return 11000
  } else if (amountMoney < 500001) {
    return 14000
  } else if (amountMoney < 600001) {
    return 17000
  } else {
    //～、100,000円増すごとに　3,000円ずつ加算
    return 17000 + 3000 * Math.ceil((amountMoney - 600000) / 100000)
  }
}

function calcLongTerm(amountMoney) {
  if (amountMoney < 100001) {
    return 4000
  } else if (amountMoney < 150001) {
    return 6000
  } else if (amountMoney < 200001) {
    return 8000
  } else if (amountMoney < 250001) {
    return 10000
  } else if (amountMoney < 300001) {
    return 12000
  } else if (amountMoney < 350001) {
    return 14000
  } else if (amountMoney < 400001) {
    return 16000
  } else if (amountMoney < 450001) {
    return 18000
  } else if (amountMoney < 500001) {
    return 20000
  } else if (amountMoney < 550001) {
    return 22000
  } else if (amountMoney < 600001) {
    return 24000
  } else {
    //～、100,000円増すごとに　3,000円ずつ加算
    return 24000 + 2000 * Math.ceil((amountMoney - 600000) / 50000)
  }
}

function getByCourse(amountMoney, courseCode) {
  if (courseCode === COURSE_MAP.NORMAL.code) {
    return calcNormal(amountMoney)
  } else if (courseCode === COURSE_MAP.LEEWAY.code) {
    return calcLeeway(amountMoney)
  } else if (courseCode === COURSE_MAP.LONG_TERM.code) {
    return calcLongTerm(amountMoney)
  } else if (courseCode === COURSE_MAP.THIRTY_THOUSAND.code) {
    return 30000
  } else if (courseCode === COURSE_MAP.FIFTY_THOUSAND.code) {
    return 50000
  }
  return 100000
}

function calcMonthlyPaymentMoney(amountMoney, loanBalance, courseCode, planCode) {
  let monthlyPayment
  if (planCode === PLAN_MAP.FLAT_RATE_REVOLVING.code) {
    monthlyPayment =
      courseCode === COURSE_MAP.LEEWAY.code
        ? getByCourse(amountMoney, courseCode) // ゆとりだと全ての残金で計算
        : getByCourse(loanBalance, courseCode) // それ以外は、このループ処理で差し引いた残金で計算
  } else {
    monthlyPayment = 10000000 // 定額リボルビング以外は一律、1千万(?)
  }
  return monthlyPayment
}

export function calcPaymentMoney(amountMoney, loanBalance, commission, courseCode, planCode) {
  const monthlyPayment = calcMonthlyPaymentMoney(amountMoney, loanBalance, courseCode, planCode)
  const ADDITIONAL_PAYMENT = 1000
  let paymentMoney = monthlyPayment
  let additionalTotal = 0

  if (commission >= monthlyPayment) {
    // 手数料のほうが月の支払額より高い場合
    while (commission >= paymentMoney && additionalTotal < 5001) {
      // 手数料が月額支払以上 && 追加金額が5000円以下なら加算する
      // 月額支払が高くなるまで、もしくは追加金額が6000円以上になるまで
      paymentMoney += ADDITIONAL_PAYMENT // 月の支払額に1000円加算
    }
  }
  if (loanBalance + commission < monthlyPayment) {
    // ローン残金 + 手数料 < 月の支払額 なら、残りの支払いは「ローン残金 + 手数料」でよい
    paymentMoney = loanBalance + commission
  }
  return { paymentMoney, monthlyPayment }
}
